<template>
  <div class="news-category">
    <div class="container-fluid">
      <b-form class="category-search-form" @submit.prevent="onSubmit">
        <b-form-group>
          <fa-icon icon="search" class="input-icon"></fa-icon>
          <img
            class="input-clear"
            src="../assets/img/common/input-clear.png"
            alt="Search Clear"
            @click="searchClear">
          <b-form-input
            v-model="newsTypesFilter.keyword"
            class="form-control-custom"
            placeholder="ค้นหาประเภทข่าว">
          </b-form-input>
        </b-form-group>
      </b-form>
    </div>

    <template v-for="(newsType, index) in newsTypes">
      <div
          class="category"
          @click="$router.push(`/news/type/${newsType.id}`)">

        <div class="image-wrapper">

          <div   v-if="newsType.news_type_logo"
                class="logo-image-cover">
            <img class="logo-image" :src="newsType.news_type_logo">
          </div>



        </div>

        <div class="title">{{ newsType.type }}</div>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'news-category',

    computed: {
      // Map Vuex state.
      ...mapState({
        newsTypes: state => {
          return state.News.newsTypes.map(newsType => {
            let image = ''
            switch (newsType.id) {
              case 1:
                image = '/static/img/news/news-category-work.png'
                break
              case 2:
                image = '/static/img/news/news-category-finance.png'
                break
              case 3:
                image = '/static/img/news/news-category-travel.png'
                break
              case 4:
                image = '/static/img/news/news-category-education.png'
                break
              case 5:
                image = '/static/img/news/news-category-health.png'
                break
              default:
                image = null
            }

            return {
              ...newsType,
              image: image
            }
          })
        },
        newsTypesFilter: state => {
          return state.News.newsTypesFilter
        }
      })
    },

    created () {
      return this.$store.dispatch('News/getNewsTypes')
    },

    methods: {
      onSubmit () {
        return this.$store.dispatch('News/getNewsTypes')
      },
      searchClear () {
        this.$store.dispatch('News/setNewsTypesFilter', {
          keyword: ''
        })
          .then(() => this.$store.dispatch('News/getNewsTypes'))
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../styles/styles";

  .logo-image{
    height: 100%;
    display:block;
    margin-left: auto;
    margin-right: auto;
    width: 100%;
    border-radius: 50%;
  }

  .logo-image-cover{
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    height: 100%;
    border-radius: 50%;
  }

  .news-category {
    padding: 20px 0;

    .image-wrapper {
      border: 2px solid #DADADA;
      box-sizing: border-box;
      box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
      border-radius: 50%;
      padding: 2px;
      width: 85px;
      height: 85px;
      flex: none;
      .image {
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
        height: 100%;
        border-radius: 50%;
      }
    }

    .category {
      @extend .cursor-pointer;
      @extend .d-flex;
      padding: 20px;
      &:not(:last-child) {
        border-bottom: 1px solid $border-color;
      }
      .image {
        width: 70px;
        height: 70px;
      }
      .title {
        @extend .flex-grow-1;
        font-size: 18px;
        color: $news-color;
        padding-left: 20px;
        line-height: 70px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/NewsCategory.component.vue